import slugify from 'slugify';

export default function createSlug(str) {
    return slugify(str, {
        lower: true,
        strict: true,
    });
}
